import styled from "styled-components";

export const AllContainer = styled.div`
    margin: 0 50px 0 50px;
`;
